module.exports = __webpack_public_path__ + "img/btn_menu_jyz_c.3acbbed6.png";